import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from '../state/auth.state';

export const selectAuthFeature: MemoizedSelector<object, AuthState> = createFeatureSelector<AuthState>('auth');

